import React from "react";
import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const McpKeyCreatedDialog = ({ open, onClose, created, labels, onCopy }) => {
  const fields = [
    { label: labels.keyLabel, value: created?.apiKey },
    { label: labels.mcpUrlLabel, value: created?.mcpUrl },
  ].filter((field) => field.value);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (!reason) onClose();
      }}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: "bold", color: "#003D78" }}>
        {labels.title}
      </DialogTitle>

      <DialogContent dividers>
        <Alert severity='warning' sx={{ mb: 2 }}>
          <AlertTitle>{labels.warningTitle}</AlertTitle>
          {labels.warning}
        </Alert>

        {fields.map((field) => (
          <TextField
            key={field.label}
            fullWidth
            size='small'
            label={field.label}
            value={field.value}
            sx={{ mb: 2 }}
            InputProps={{
              readOnly: true,
              sx: { fontFamily: "monospace", fontSize: "0.8rem" },
              endAdornment: (
                <InputAdornment position='end'>
                  <Tooltip title={labels.copy}>
                    <IconButton
                      size='small'
                      onClick={() => onCopy(field.value)}
                      aria-label={`${labels.copy} ${field.label}`}
                    >
                      <ContentCopyIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        ))}

        {labels.hint && (
          <Typography variant='body2' color='text.secondary'>
            {labels.hint}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant='contained'
          sx={{ backgroundColor: "#003D78" }}
        >
          {labels.done}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default McpKeyCreatedDialog;
